<template>

<com-content class="bookings">
    
    <iframe ref="embed" :src="page.business.bookings" class="bookings-embed" :style="{height: height + 'px'}" />

</com-content>

</template>

<script>

import comContent from './common/Content'

export default {

    components: {
        'com-content': comContent
    },

    data: function() {

        return {
            height: 200
        }

    },

    created: function() {

        window.addEventListener('message', this.onMessageReceived.bind(this))
	
		document.title = [
			this.page.bookings_meta_title,
			this.page.business.name,
			this.settings.meta_suffix
		].join(' | ')

    },

    beforeDestroy: function() {

        window.removeEventListener('message', this.onMessageReceived.bind(this))

    },

    methods: {

        onMessageReceived: function(e) {

            if (e.data.height) this.height = e.data.height

        }

    }

}

</script>

<style scoped>

.bookings-embed {
    min-height: 200px;
    width: 100%;
}

</style>